/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../VisDefinitionAPI',
	'./VisDefinitionAPISpec',
	'../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./SlotDefinition',
	'./VisDefinitionState'],
(_, VisDefinitionAPI, VisDefinitionAPISpec, APIFactory, SlotDefinition, VisDefinitionStateImpl) => {

	class VisDefinitionImpl extends VisDefinitionAPISpec {
		constructor(visSpec, visDefinitionManager) {
			super();
			this.visDefinitionManager = visDefinitionManager;
			this.visSpec = visSpec;
			// We hold on to the impl so that we can destroy the objects.
			this.slotDefinitionImpls = [];
			this.slotDefinitionAPIs = [];
			this._visDefinitionStateImpl = new VisDefinitionStateImpl();
		}

		destroy() {
			if (this.slotDefinitionImpls){
				this.slotDefinitionImpls.forEach(def => def.destroy());
			}
			this.slotDefinitionImpls = null;
			this.visDefinitionManager = null;
			this.visSpec = null;
			this.slotDefinitionAPIs = null;
			this._visDefinitionStateImpl = null;
		}
		getAPI() {
			return APIFactory.createAPI(this, [VisDefinitionAPI]);
		}

		getType() {
			return this.visSpec.type;
		}

		getId() {
			return this.visSpec.id;
		}

		getDatasetList() {
			return _.map(this.visSpec.datasets, function(dataset){
				return {
					id: dataset.name,
					caption: dataset.caption,
					optional: dataset.optional,
					suppressMissing: dataset.suppressMissing,
					needsSorted: dataset.needsSorted,
					requiresValues: dataset.requiresValues
				};
			});
		}

		getLabel(){
			return this.visSpec.label;
		}

		getIcon() {
			return this.visSpec.icon;
		}

		getIconUri() {
			return this.visSpec.iconUri;
		}

		getPlaceholderIconUri() {
			return this.visSpec.placeholderIcon;
		}

		getPreferredSize(){
			return this.visSpec.preferredSize;
		}

		getSlot(id) {
			return this.getSlotList().find((slot) => (slot.getId() === id));
		}

		getSlotList() {
			if (this.slotDefinitionAPIs.length === 0) {
				_.each(this.visSpec.dataSlots, (slot) => {
					const impl = new SlotDefinition(slot);
					this.slotDefinitionImpls.push(impl);
					this.slotDefinitionAPIs.push(impl.getAPI());
				});
			}
			return this.slotDefinitionAPIs;
		}

		getMultiEdgeSort() {
			return this.visSpec.queryHints && this.visSpec.queryHints.multiEdgeSort;
		}

		getDefaultDatasetId() {
			return this.visSpec.defaultDatasetId||undefined;
		}

		getState() {
			return this._visDefinitionStateImpl.getAPI();
		}

		setError(error) {
			this._visDefinitionStateImpl.setError(error);
		}

		refresh() {
			const visId = this.visSpec.id;
			return this.visDefinitionManager.refresh(visId).then((newDef) => {
				this.visSpec = newDef;
				if (this.getState().getError() && !newDef.empty) {
					this.setError(undefined); //only if an error is undefined is treated as no error, ref livewidget=>isInvalidVisDefinition
				}
				//clear the slot def cache
				this.slotDefinitionAPIs = [];
				return newDef;
			});
		}

		getProperty(id) {
			return this.visSpec[id];
		}
	}

	return VisDefinitionImpl;
});
